import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import type { ChildItemsState, ChildMonitoredItem } from './types';

const initialState: ChildItemsState = {
  items: [],
  hasLoaded: false,
};

const childItemsSlice = createAppSlice({
  name: 'childItems',
  initialState,
  reducers: {
    setChildItems: (state, action: PayloadAction<ChildMonitoredItem[]>) => {
      state.items = action.payload ?? [];
      state.hasLoaded = true;
    },
  },
});

export const { setChildItems } = childItemsSlice.actions;
export default childItemsSlice.reducer;
